import api from "../../../../api";

export function getInternalTickets(sd, ed) {
	return api.get(`get-internal-tickets?startDate=${sd}&endDate=${ed}`)
}